import { initializeApp } from 'firebase/app';

const app = initializeApp({
  apiKey: "AIzaSyDOlKjbqjxvggyo7Yx7s-lo01Rt4vFn36s",
  //authDomain: "",
  databaseURL: "https://dawn-of-the-monster-invasion.firebaseio.com/",
  projectId: "dawn-of-the-monster-invasion",
  //storageBucket: "",
  //messagingSenderId: ""
});

export const db = app.firestore();
export const roomsCollection = db.collection('rooms');
export const rtdb = app.database();